import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CustomerServiceModuleName,
    LoggingModuleName,
    LqbPricerLogModuleName,
    LqbPricerParamsServiceModuleName,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {CalculationsLoggingControllerName} from "../utils/names/controllerNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const CalculationLoggingModuleConfiguration = new RestrictedRouteModuleConfiguration(
    LoggingModuleName,
    [
        LoggingModuleName,
        LqbPricerParamsServiceModuleName,
        LqbPricerLogModuleName,
        AngularJsMaterialModuleName,
        CustomerServiceModuleName,
        UserServiceModuleName
    ],
    [
        ["/logging/calc", {
            template: require("./route/logging.html"),
            controller: CalculationsLoggingControllerName
        }]
    ],
    [
        new NavigationItem({
            title: "Logging",
            href: "#!logging/calc",
            accessRole: [NavigationAccessRoles.ROLE_USER],
            activeFunction: routeName => routeName.indexOf("logging") !== -1 && routeName.indexOf("calc") !== -1
        })
    ],
    [LoggingModuleName],
    [UserGranredAuthorityName.LOGGING],
    getTabName() + '| Logging'
);

export default CalculationLoggingModuleConfiguration;